import {connect} from 'react-redux';
import includes from 'lodash/includes';
import compose from 'recompose/compose';
import {bindActionCreators} from 'redux';
import * as ResourceApi from 'api/resources';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {Types as ResourceTypes} from 'api/resources';
import MasterSearchBar from './MasterSearchBar';
import {searchQueryChanged, clearSearchResults} from './actions';
import {startEditImageAction} from 'pages/Images/actions';
import {unmountBreak} from 'pages/EditBreak/actions';
import {
  RenderedElsewhere,
  DisabledPathRegexps,
  mapPathnameToResourceType,
  normalizeResource,
  normalizeBreak,
  normalizeImage
} from './utils';


const mapStateToProps = (state, ownProps) => {
  const {searchResults, fetching} = state.masterSearch;
  const {pathname} = ownProps.router.location;
  const type = mapPathnameToResourceType(pathname);

  const resultsRenderedElsewhere = includes(RenderedElsewhere, type);

  // munge results into a consistent shape for rendering
  const normalizedResults = resultsRenderedElsewhere ? [] : searchResults.map(
    type === ResourceApi.Types.Break
      ? normalizeBreak
      : type === ResourceApi.Types.Image ? normalizeImage : normalizeResource
  );

  return {
    resultsRenderedElsewhere,
    disabled: DisabledPathRegexps.some(regexp => regexp.test(pathname)),
    resourceType: type,
    fetching,
    searchResults: normalizedResults
  };
};

const mapDispatchToProps = {
  searchQueryChanged,
  clearSearchResults,
  unmountBreak,
  startEditImage: startEditImageAction,
};

export default  compose(
  setDisplayName('MasterSearchBarContainer'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    searchResults: props.resourceType === ResourceTypes.Break
      ? props.searchResults.map(result => ({...result, onClick: props.unmountBreak}))
      : props.searchResults
  }))
)(MasterSearchBar);



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/MasterSearchBarContainer.js